module.exports = __webpack_public_path__ + "static/media/pdfIcon.1b0a115c.svg";